import { render, staticRenderFns } from "./ProgramadorInformeEstadoDocentes.vue?vue&type=template&id=581f2d48&"
import script from "./ProgramadorInformeEstadoDocentes.vue?vue&type=script&lang=js&"
export * from "./ProgramadorInformeEstadoDocentes.vue?vue&type=script&lang=js&"
import style0 from "./ProgramadorInformeEstadoDocentes.vue?vue&type=style&index=0&id=581f2d48&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports